import { Button } from '@components/ui'
import { useMutation, useQuery } from '@tanstack/react-query'
import { Col, Flex, Form, Input, Row } from 'antd'
import { useState } from 'react'

import { useFramework } from '@suntex.fim/framework'
import { useSchool } from '@suntex.fim/school'
import { Select } from '@suntex.fim/ui'

function BasicInformation() {
  const { api } = useFramework()
  const { schoolId } = useSchool()
  const [contactId, setContactId] = useState<number>()
  const { data, isError, isLoading } = useQuery({
    queryKey: ['school', 'edit', schoolId],
    queryFn: () => api.get_School_Edit({ schoolId: schoolId! }),
    enabled: schoolId !== null
  })
  const updateContact = useMutation({
    mutationFn: (selectedContactId: number) =>
      api.post_School_UpdateContact({
        schoolId: schoolId!,
        contactId: selectedContactId
      })
  })

  if (schoolId === null) return <p>School information is unavailable.</p>
  if (isLoading) return <p>Loading school information...</p>
  if (isError || !data) return <p>Unable to load school information.</p>

  return (
    <Flex vertical gap="20px">
      <Row gutter={10} className="main-navigation">
        <Col>
          <Flex gap="10px" className="main-navigation__heading" align="center">
            <h3>Basic Information</h3>
          </Flex>
        </Col>
      </Row>
      <Form
        layout="vertical"
        className="my-account__form"
        style={{ maxWidth: 680 }}
      >
        <Row gutter={20}>
          <Col lg={12} sm={24}>
            <Form.Item label="School">
              <Input value={data.school.name} readOnly />
            </Form.Item>
          </Col>
          <Col lg={12} sm={24}>
            <Form.Item label="Contact to verify">
              <Select.One
                value={contactId}
                onChange={setContactId}
                options={data.contacts.map((contact) => ({
                  value: contact.id,
                  label:
                    contact.displayName ??
                    contact.name ??
                    contact.email ??
                    `Contact ${contact.id}`
                }))}
              />
            </Form.Item>
          </Col>
        </Row>
        <Button
          disabled={contactId === undefined || updateContact.isPending}
          onClick={() =>
            contactId !== undefined && updateContact.mutate(contactId)
          }
        >
          {updateContact.isPending
            ? 'Submitting...'
            : 'Submit & Verify Contact Info'}
        </Button>
        {updateContact.isSuccess && <p>Contact information submitted.</p>}
        {updateContact.isError && <p>Unable to submit contact information.</p>}
      </Form>
    </Flex>
  )
}

export default BasicInformation
